module.exports = __webpack_public_path__ + "static/img/bg2.2ed9e6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/connect/bg2.png
// module id = ck/8
// module chunks = 7